import Constants from 'controllers/constants';
import { api } from 'controllers/network/apiClient';
import { ContactCard } from 'types';

interface ContactCardsResponse {
  success: boolean;
  data: {
    vcards: ContactCard[];
  };
}
export const fetchContactCards = async (): Promise<ContactCard | undefined> => {
  const response: ContactCardsResponse = await api.get(`vcards`);

  if (response.success) {
    return response.data.vcards?.[0];
  }
};

export const getContactCardURL = (shopId: number): string => {
  const { internalApiHost } = Constants;

  return `${internalApiHost}/vcards/file/${shopId}`;
};

export const isContactCardURL = (url: string): boolean => {
  return url.includes('vcards');
};

export const convertShopNameToContactFileName = (shopName: string): string => {
  return `${shopName.trim().split(' ').join('')}.vcf`;
};
